var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6488 11.0307L12.1488 15.5307C12.0079 15.6716 11.8168 15.7508 11.6175 15.7508C11.4183 15.7508 11.2272 15.6716 11.0863 15.5307C10.9454 15.3898 10.8662 15.1987 10.8662 14.9995C10.8662 14.8002 10.9454 14.6091 11.0863 14.4682L14.3057 11.2501H5.11816C4.91925 11.2501 4.72849 11.1711 4.58783 11.0304C4.44718 10.8898 4.36816 10.699 4.36816 10.5001C4.36816 10.3012 4.44718 10.1104 4.58783 9.96978C4.72849 9.82913 4.91925 9.75011 5.11816 9.75011H14.3057L11.0875 6.53011C10.9466 6.38921 10.8675 6.19812 10.8675 5.99886C10.8675 5.7996 10.9466 5.60851 11.0875 5.46761C11.2284 5.32671 11.4195 5.24756 11.6188 5.24756C11.818 5.24756 12.0091 5.32671 12.15 5.46761L16.65 9.96761C16.72 10.0374 16.7754 10.1203 16.8132 10.2115C16.851 10.3028 16.8704 10.4006 16.8703 10.4994C16.8702 10.5982 16.8506 10.696 16.8126 10.7872C16.7745 10.8784 16.7189 10.9611 16.6488 11.0307Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.23f264145ed5ca319e6aa12b143817bc.svg";
export { ForwardRef as ReactComponent };